<template>
  <footer class="w-full bg-[#1D3C7D] relative overflow-hidden">
    <!-- 背景水印 -->
    <div class="absolute right-0 top-0 bottom-[40px] pointer-events-none w-[45%] hidden md:block">
      <img
        src="../../assets/img/footer-bg.webp"
        alt="footer_watermark"
        class="w-full h-full object-contain"
      />
    </div>

    <!-- 主要内容区域 -->
    <div class="relative z-10 py-4 sm:py-6 md:py-[20px] container mx-auto px-4 sm:px-6">
      <!-- 导航信息区（上部） -->
      <div class="grid grid-cols-1 md:grid-cols-2 
      lg:grid-cols-10 gap-6 sm:gap-8 lg:gap-12 mb-8 sm:mb-10 md:mb-12 ">
        <!-- 第一列：首页 -->
        <div class="flex flex-col text-left lg:col-span-1">
          <h3
            class="text-white text-[16px] sm:text-[17px] md:text-[24px] mb-4 md:mb-[6px] cursor-pointer"
            @click="router.push('/home.html')"
          >首页</h3>
        </div>

        <!-- 第二列：产品 -->
        <div class="flex flex-col lg:col-span-3">
          <h3
            class="text-white text-[16px] sm:text-[17px] md:text-[24px] mb-4 md:mb-[6px] cursor-pointer"
            @click="router.push('/product.html')"
          >产品</h3>
          <ul
            v-if="productList.length > 0"
            class="flex flex-col gap-2 sm:gap-3"
          >
            <template
              v-for="(productType, typeIndex) in productList"
              :key="typeIndex"
            >
              <!-- 产品类型标题 -->
              <li
                v-if="typeIndex > 0"
                class="mt-3 sm:mt-4"
              >
                <div class="text-white text-[14px] sm:text-[15px] md:text-[16px] font-semibold mb-2 sm:mb-3">
                  {{ productType.productTypeName }}
                </div>
                <ul class="flex flex-col gap-1">
                  <!-- 产品列表 -->
                  <li
                    v-for="product in productType.products"
                    :key="product.id"
                  >
                    <router-link
                      :to="getProductRoute(product)"
                      class="flex items-center gap-2 text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                    >
                      <img
                        v-if="product.icon"
                        :src="product.icon"
                        :alt="product.name"
                        class="w-4 h-4 rounded object-cover shrink-0"
                        @error="handleImageError"
                      />
                      <span class="break-words">{{ product.name }}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <!-- 第一个类型：XR大空间互动影片内容播控系统（无图标，直接显示） -->
              <template v-else>
                <li>
                  <div class="text-white text-[14px] sm:text-[15px] md:text-[16px] font-bold hover:text-white transition-colors">
                    {{ productType.productTypeName }}
                  </div>
                </li>
                <li
                  v-for="product in productType.products"
                  :key="product.id"
                >
                  <router-link
                    :to="getProductRoute(product)"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    {{ product.name }}
                  </router-link>
                </li>
              </template>
            </template>
          </ul>
          <!-- 加载中或空状态 -->
          <div
            v-else
            class="text-white/60 text-[12px] sm:text-[13px] md:text-[14px]"
          >
            加载中...
          </div>
        </div>

        <!-- 第三列：解决方案 -->
        <div class="lg:col-span-2">
          <div class="flex flex-col justify-between">
            <div>
              <h3
                class="text-white text-[16px] sm:text-[17px] md:text-[24px] mb-4 md:mb-[6px] cursor-pointer"
                @click="router.push('/solution.html')"
              >解决方案</h3>
              <ul class="flex flex-row flex-wrap gap-x-6 gap-y-2 md:flex-col md:flex-nowrap md:gap-2 sm:md:gap-3">
                <li>
                  <router-link
                    to="/xr-theater.html"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    XR剧院内容及管理方案
                  </router-link>
                </li>
                <!-- <li>
                  <router-link
                    to="/xr-home.html"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    XR大空间地产家装方案
                  </router-link>
                </li> -->
                <li>
                  <router-link
                    to="/lbe-custom.html"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    LBE大空间定制开发方案
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/vrSpaceSolutions.html"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    VR 大空间方案
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/xr-immersiveLearning.html"
                    class="text-white/80 text-[12px] sm:text-[13px] md:text-[14px] hover:text-white transition-colors"
                  >
                    XR沉浸式研学方案
                  </router-link>
                </li>
              </ul>
            </div>
            <ul class="flex flex-row flex-wrap gap-x-6 gap-y-2 mt-4 md:mt-0 md:flex-col md:flex-nowrap md:justify-start md:gap-2 lg:gap-3">
              <li class="md:mt-3 lg:mt-4">
                <router-link
                  to="/service.html"
                  class="text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] hover:text-white/90 transition-colors
                font-normal
                "
                >
                  服务案例
                </router-link>
              </li>
              <li>
                <router-link
                  to="/news.html"
                  class="text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] hover:text-white/90 transition-colors   font-normal"
                >
                  资讯中心
                </router-link>
              </li>
              <li>
                <router-link
                  to="/contact.html"
                  class="text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] hover:text-white/90 transition-colors font-normal"
                >
                  联系我们
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 第四列：联系方式 -->
        <div class="relative flex flex-col lg:col-span-4 justify-end">
          <!-- 半透明背景框，显示EMUSHOW logo -->
          <div class="absolute inset-0 rounded-lg z-0"></div>

          <!-- 内容区域 -->
          <div class="relative z-10 pt-0 md:pt-[10%] lg:pt-[20%]">
            <div class="flex flex-col sm:flex-row items-start sm:items-end justify-start gap-4 sm:gap-4">
              <!-- 联系电话 -->
              <div class="gap-2 sm:gap-3 flex flex-col">
                <div class="w-full flex flex-row justify-center items-baseline gap-2 whitespace-nowrap md:w-auto md:flex-col md:justify-start md:gap-0 md:whitespace-normal">
                  <div class="text-white text-[16px] sm:text-[18px] md:text-[20px]">联系电话:</div>
                  <a
                    href="tel:13052585965"
                    class="text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] font-bold hover:text-white/80 transition-colors block"
                  >
                    130 5258 5965
                  </a>
                </div>
                <div class="text-white text-[16px] sm:text-[18px] md:text-[20px] mt-2 sm:mt-0">联系地址:</div>
              </div>

              <!-- 二维码区域 -->
              <div class="flex flex-row gap-3 sm:gap-4">
                <div class="flex flex-col items-center">
                  <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">

                    <img
                      :src="productCodeImg"
                      alt="产品支持二维码"
                      class="w-full h-full object-contain"
                    />
                  </div>
                  <div class="text-white text-[11px] sm:text-[12px] md:text-[14px]">产品支持</div>
                </div>
                <div class="flex flex-col items-center">
                  <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">

                    <img
                      :src="coopCodeImg"
                      alt="合作咨询二维码"
                      class="w-full h-full object-contain"
                    />
                  </div>
                  <div class="text-white text-[11px] sm:text-[12px] md:text-[14px]">合作咨询</div>
                </div>
              </div>

            </div>

            <!-- 联系地址 -->
            <div class="mt-3 sm:mt-2">
              <div class="text-white text-[16px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold wrap-break-words">
                上海市闵行区万芳路515号A座8层</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 版权信息区（下部） -->
      <div class="pt-4 sm:pt-5 md:pt-6 mt-6 sm:mt-7 md:mt-8">
        <div class="text-white text-[12px] sm:text-[14px] md:text-[16px]  lg:text-[20px] text-center font-normal leading-relaxed">
          Copyright © 2023-2025 易目秀信息科技(上海)有限公司. All rights reserved. 备案号:<span class="underline">沪ICP备2024095500号-1</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import productCode from "@/assets/img/product-code.webp";
import coopCode from "@/assets/img/coop-code.webp";
import { productApi, type ProductType } from "@/api";
import { RequestError } from "@/utils/request";
import { useRouter } from "vue-router";

const router = useRouter();

// 产品列表数据
const productList = ref<ProductType[]>([]);

// 二维码图片
const productCodeImg = ref(productCode);
const coopCodeImg = ref(coopCode);

/**
 * 根据产品生成路由路径
 * 跳转到 /product/:id.html
 */
const getProductRoute = (product: { name: string; id: string }): string => {
  if (product.name === "ENUMSHOW播控系统") {
    return "/product.html";
  } else {
    return `/product/${product.id}.html`;
  }
};

/**
 * 图片加载错误处理
 */
const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement;
  img.style.display = "none";
};

/**
 * 加载产品列表
 */
const loadProductList = async () => {
  try {
    const response = await productApi.getProductList();
    if (response.code === 200 && response.data) {
      productList.value = response.data;
    }
  } catch (error) {
    console.error("加载产品列表失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
  }
};

onMounted(() => {
  loadProductList();
});
</script>

<style scoped lang="scss">
footer {
  // 确保footer在页面底部
  margin-top: auto;
}
</style>
